// Notification utilities for browser notifications

export const requestNotificationPermission = async (): Promise<boolean> => {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission === 'denied') {
    console.warn('Notification permission was denied');
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const showNotification = (title: string, options?: NotificationOptions): void => {
  if (Notification.permission === 'granted') {
    try {
      new Notification(title, {
        icon: '/favicon.ico', // Use app favicon
        badge: '/favicon.ico',
        ...options,
      });
    } catch (error) {
      console.error('Error showing notification:', error);
    }
  }
};

export const getReminderDateTime = (reminder: { date: string; time?: string }): Date => {
  const dateTimeString = reminder.time
    ? `${reminder.date}T${reminder.time}:00`
    : `${reminder.date}T00:00:00`;
  return new Date(dateTimeString);
};

export const isReminderUpcoming = (reminder: { date: string; time?: string }, minutesAhead: number = 60): boolean => {
  const reminderDateTime = getReminderDateTime(reminder);
  const now = new Date();
  const timeDiff = reminderDateTime.getTime() - now.getTime();
  const minutesDiff = timeDiff / (1000 * 60);
  return minutesDiff > 0 && minutesDiff <= minutesAhead;
};

export const isReminderRecent = (reminder: { date: string; time?: string }, hoursAgo: number = 12): boolean => {
  const reminderDateTime = getReminderDateTime(reminder);
  const now = new Date();
  const timeDiff = now.getTime() - reminderDateTime.getTime();
  const hoursDiff = timeDiff / (1000 * 60 * 60);
  return hoursDiff > 0 && hoursDiff <= hoursAgo;
};
